<script>
    import {Route, Link} from './router';
    import app from "./stores/app";
    import {geosBackup, geosRestore} from "./lib/requests";
    import Loader from './components/Loader.svelte';
    import Confirm from "./AppAlert.svelte";
    import ErrorMessage from './ErrorMessage.svelte';
    import SuccessMessage from './SuccessMessage.svelte';
    import LocationsTree from "./tests/LocationsTree.svelte";
    import app_alert from "./stores/alerts";
    import success from "./stores/success";
    import Geos from "./geos/Geos.svelte";
    import Categories from "./categories/Categories.svelte";
    import Attributes from "./attributes/Attributes.svelte";
    import GeosMatch from "./geos_match/GeosMatch.svelte";
    import Login from "./components/Login.svelte";
    import {USER_COOKIE} from "./lib/constants";
    import {cookie} from "./lib/cookie";

    let userToken = null;
    let initialized = true;

    const initUser = async () => {
        // user.initialize();
        let coo = cookie.get(USER_COOKIE) || null;
        if (coo && coo !== 'null') {
            userToken = coo;
        }
    }

    const Backup = () => {
        app_alert.show("confirm", "Να γίνει backup στις περιοχές;", async () => {
            const [err, res] = await geosBackup();

            if (err) {
                alert('error ' + err)
                return;
            }

            success.show("Το backup ολοκληρώθηκε.");
        });
    }

    const Restore = () => {
        app_alert.show("confirm", "Να γίνει restore στις περιοχές;", async () => {
            const [err, res] = await geosRestore();

            if (err) {
                alert('error ' + err)
                return;
            }

            success.show("Το restore ολοκληρώθηκε.");
        });
    }

    initUser();

    window.addEventListener('resize', function (event) {
        app.windowResize();
    });
    app.windowResize();
</script>

{#if userToken == null}
<Login bind:userToken />
{:else}
    {#if initialized}
        <Route match="app">
            <header class="header fixed-top clearfix">
                <div class="brand">
                    <div class="logo">
                        <Link style="color: inherit;" href="/app">KA - TOOLS</Link>
                    </div>
                </div>
                <div class="nav notify-row">
                    <ul class="nav top-menu">
                        <li>
                            <Link css_class="menu-item menu-button smooth-trans" href="/app/geos-match">Golden Home
                            </Link>
                        </li>
                        <li>
                            <Link css_class="menu-item menu-button smooth-trans" href="/app/attributes">Χαρακτηριστικά
                            </Link>
                        </li>
                        <li>
                            <Link css_class="menu-item menu-button smooth-trans" href="/app/categories">Κατηγορίες
                            </Link>
                        </li>
                        <li>
                            <Link css_class="menu-item menu-button smooth-trans" href="/app/geos">Περιοχές</Link>
                        </li>
                    </ul>
                </div>
            </header>

            <div class="container-fluid main-container">
                <Route match="geos-match">
                    <GeosMatch/>
                </Route>
                <Route match="geos">
                    <Geos/>
                </Route>
                <Route match="categories">
                    <Categories/>
                </Route>
                <Route match="attributes">
                    <Attributes/>
                </Route>
            </div>
        </Route>
    {/if}
{/if}

<LocationsTree/>
<ErrorMessage/>
<SuccessMessage/>
<Confirm/>
<Loader/>


